import React from 'react'

import Slider from 'react-slick'

import { SlideinWrap, SlideinItem } from 'src/components/slidein/index'

import Image from 'src/components/image/dynamic'

import * as styles from './gallery.module.scss'


const Gallery = ({ images, align }) => {

    if (images.length > 1) {

        const config = {
            dots: false,
            arrows: false,
            infinite: false,
            speed: 500,
        }

        return (
            <SlideinWrap className={styles.slide}>
                <Slider {...config}>
                    {images.map((image, i) => (
                        <div key={i}>
                            {i === 0 ? (
                                <React.Fragment>
                                    <SlideinItem className={styles.image}>
                                        <Image imagePC={image.imagePc} imageSP={image.imageSp} />
                                    </SlideinItem>
                                    {image.caption && (
                                        <SlideinItem delay={300} className={styles.caption} data-align={align}>
                                            {image.caption}
                                        </SlideinItem>
                                    )}
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <div className={styles.image}>
                                        <Image imagePC={image.imagePc} imageSP={image.imageSp} />
                                    </div>
                                    {image.caption && (
                                        <div className={styles.caption} data-align={align}>
                                            {image.caption}
                                        </div>
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    ))}
                </Slider>
            </SlideinWrap>
        )
    } else {
        return (
            <SlideinWrap>
                <SlideinItem className={styles.image}>
                    <Image imagePC={images[0].imagePc} imageSP={images[0].imageSp} />
                </SlideinItem>
                {images[0].caption && (
                    <SlideinItem delay={300} className={styles.caption} data-align={align}>
                        {images[0].caption}
                    </SlideinItem>
                )}
            </SlideinWrap>
        )
    }
}

export default Gallery